import createHTMLMediaHook from './util/createHTMLMediaHook';
var useAudio = createHTMLMediaHook('audio');
export default useAudio;
